import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AddRespondentForm from './AddRespondentForm';
import { createRespondent } from '../../../../services/apps/RespondentServices';
import { withAccount } from '../../../../components/AccountContext';
import { withGrowl } from '../../../../components/GrowlNotifications';
import { growlErrors } from '../../../../utils/NotificationUtil';
import { growlShape } from '../../../../components/prop-types';

class AddRespondentFormContainer extends Component {
  constructor(props) {
    super(props);
    this.saveRespondent = this.saveRespondent.bind(this);
  }

  async saveRespondent(formValue) {
    const {
      currentAccount, growl, onAdd, type,
      toggleEdit,
    } = this.props;
    try {
      const result = await createRespondent({
        ...formValue,
        accountId: currentAccount,
      });

      const { createRespondent: { respondent } } = result;
      onAdd(respondent, type);
      toggleEdit(false);
    } catch (errors) {
      growlErrors(growl, errors);
    }
  }

  render() {
    const { toggleEdit } = this.props;
    return (
      // Nested form is invalid with HTML5 syntax
      // Need to make the separated fields
      <AddRespondentForm
        toggleEdit={toggleEdit}
        saveRespondent={this.saveRespondent}
      />
    );
  }
}

AddRespondentFormContainer.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  growl: growlShape.isRequired,
  onAdd: PropTypes.func.isRequired,
  toggleEdit: PropTypes.func.isRequired,
};

export default withGrowl(
  withAccount(AddRespondentFormContainer),
);
